export const SCORE_MIN = 0;
export const SCORE_MAX = 100;

export function validateStartHereConfig(startHere, products, { includeDisabled = false } = {}) {
  const errors = [];
  if (!startHere) return errors;
  // Display-time validation may skip disabled configs; publish-time passes
  // includeDisabled so a disabled-but-broken config can never publish silently.
  if (startHere.enabled === false && !includeDisabled) return errors;

  const productIds = new Set((products || []).map((product) => product.id));
  const questions = Array.isArray(startHere.questions) ? startHere.questions : [];

  const seenQuestionIds = new Set();
  for (const question of questions) {
    if (!question?.id) errors.push("Start Here question is missing id");
    if (question?.id) {
      if (seenQuestionIds.has(question.id)) {
        errors.push(`Start Here question id ${question.id} is duplicated`);
      }
      seenQuestionIds.add(question.id);
    }
    if (!question?.prompt) errors.push(`Start Here question ${question?.id || "(missing id)"} is missing prompt`);

    const options = Array.isArray(question?.options) ? question.options : [];
    const seenOptionIds = new Set();
    for (const option of options) {
      if (!option?.id) errors.push(`Start Here option in ${question.id || "(missing id)"} is missing id`);
      if (option?.id) {
        if (seenOptionIds.has(option.id)) {
          errors.push(
            `Start Here option id ${option.id} in ${question.id || "(missing id)"} is duplicated`
          );
        }
        seenOptionIds.add(option.id);
      }
      if (!option?.label) {
        errors.push(
          `Start Here option ${option?.id || "(missing id)"} in ${question.id || "(missing id)"} is missing label`
        );
      }
      const weights = Array.isArray(option?.weights) ? option.weights : [];
      for (const weight of weights) {
        if (!productIds.has(weight?.productId)) {
          errors.push(
            `${question.id || "(missing id)"}/${option.id || "(missing id)"}: unknown product ${weight?.productId || "(missing product)"}`
          );
        }
        if (typeof weight?.score !== "number" || !Number.isFinite(weight.score)) {
          errors.push(
            `${question.id || "(missing id)"}/${option.id || "(missing id)"}: score for ${weight?.productId || "(missing product)"} must be a finite number`
          );
        } else if (weight.score < SCORE_MIN || weight.score > SCORE_MAX) {
          errors.push(
            `${question.id || "(missing id)"}/${option.id || "(missing id)"}: score for ${weight?.productId || "(missing product)"} must be between ${SCORE_MIN} and ${SCORE_MAX}`
          );
        }
      }
    }
  }

  return errors;
}
